export default __webpack_public_path__ + "static/media/point-white-new-theme.ec160fd1.svg";